module.exports = __webpack_public_path__ + "img/mini-program-icon.2e373f86.jpeg";